import { toast } from "@grandvisionhq/common";
import { useWishlistId } from "@grandvisionhq/svc-wishlist";
import { pushWishlistEvent, getWishlistButtonEventInfo } from "../../data-layer/data-layer/wishlist.js";
import { useAddToShoppingList } from "./use-add-to-shopping-list.js";
import { useRemoveFromShoppinglist } from "./use-remove-from-shopping-list.js";
import { useWishlistAuthState } from "./use-wishlist-auth-state.js";
const useWishlistActions = (wishlistLocation) => {
  const { isUserLoggedIn } = useWishlistAuthState();
  const { clearWishlist } = useWishlistId();
  const { addToShoppinglist } = useAddToShoppingList({
    isLoggedIn: isUserLoggedIn,
    onCompleted: (data) => {
      if (data.addToShoppinglist.__typename === "AddToShoppinglistSuccessResponse") {
        toast.success("account.wishlist.add.success");
        const { interactionType, siteFeature } = getWishlistButtonEventInfo("add", wishlistLocation);
        pushWishlistEvent({
          siteFeature,
          interactionType,
          messageType: "item_added",
          item: { sku: data.addToShoppinglist.result.id }
        });
      }
    },
    onError: (productSkus) => {
      toast.failed("account.wishlist.add.error");
      const { interactionType, siteFeature } = getWishlistButtonEventInfo("add", wishlistLocation);
      pushWishlistEvent({
        siteFeature,
        interactionType,
        messageType: "error",
        item: { sku: productSkus[0] ?? "" }
      });
    }
  });
  const { removeFromShoppinglist } = useRemoveFromShoppinglist({
    onCompleted: (data) => {
      if (data.removeFromShoppinglist.__typename == "RemoveFromShoppinglistSuccessResponse") {
        toast.success("account.wishlist.remove.success");
        const { interactionType, siteFeature } = getWishlistButtonEventInfo(
          "remove",
          wishlistLocation
        );
        pushWishlistEvent({
          siteFeature,
          interactionType,
          messageType: "item_removed",
          item: { sku: data.removeFromShoppinglist.result?.id ?? "" }
        });
      }
      if (data.removeFromShoppinglist.__typename === "RemoveFromShoppinglistSuccessResponse" && !data.removeFromShoppinglist.result?.items.length) {
        clearWishlist();
      }
    },
    onError: (productSkus) => {
      toast.failed("account.wishlist.remove.error");
      const { interactionType, siteFeature } = getWishlistButtonEventInfo(
        "remove",
        wishlistLocation
      );
      pushWishlistEvent({
        siteFeature,
        interactionType,
        messageType: "error",
        item: { sku: productSkus[0] ?? "" }
      });
    }
  });
  return { addToShoppinglist, removeFromShoppinglist };
};
export {
  useWishlistActions
};
//# sourceMappingURL=use-wishlist-actions.js.map
